enum HoraRelogio {
    H22 = 22,
    H45 = 45,
    H50 = 50,
    H60 = 60,
}

function convertToClassHours(clockHours: HoraRelogio | null): number {
    let classHours: number;

    switch (clockHours) {
        case HoraRelogio.H22:
            classHours = 30;
            break;
        case HoraRelogio.H45:
            classHours = 60;
            break;
        case HoraRelogio.H50:
            classHours = 60;
            break;
        case HoraRelogio.H60:
            classHours = 60;
            break;
        default:
            classHours = 0;
            break;
    }

    return classHours;
}

function getClockHoursEnumFromNumber(number: number): HoraRelogio | null {
    const enumValues = Object.values(HoraRelogio);
    const enumValue = enumValues.find((value) => value === number) as
        | HoraRelogio
        | undefined;

    return enumValue ?? null;
}

export { HoraRelogio, convertToClassHours, getClockHoursEnumFromNumber };
